import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import {Headers, Http, RequestMethod, RequestOptions, URLSearchParams} from "@angular/http";
import {Router} from "@angular/router";
import {environment} from "../../environments/environment";
import {RequestConfig} from "../shared/rest/rest.request";
import {isNullOrUndefined} from "util";
import {Subject} from "rxjs/Subject";
import { UsersService } from '../+admin/+users/users.service';
import { userInfo } from 'os';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class AuthService {
    private LOG_OUT: RequestConfig = new RequestConfig("AC003", "application/json", true, RequestMethod.Post, "/users/secure/logout");
    private UPDATE_PASSWORD: RequestConfig = new RequestConfig("AC003", "application/json", true, RequestMethod.Put, "/users/updatePassword");

    private _token: TokenManager;
    public _refreshing: Subject<TokenManager> = new Subject<TokenManager>();
    public _isTokenRefreshing: boolean = false;

    constructor(@Inject(Http) private http: Http,
                @Inject(Router) public router) {
        this._token = <TokenManager>JSON.parse(localStorage.getItem("auth_token"));
        if (isNullOrUndefined(this._token)) {
            console.warn(`Token from local storage was null`)
            localStorage.removeItem("auth_token");
            localStorage.removeItem("info_user_logged");
            localStorage.removeItem("cajero");

            //Cokies//
            localStorage.removeItem('userData');
            localStorage.removeItem('groupsAll');
            localStorage.removeItem('allTypesTicket');
            localStorage.removeItem('userGroupsAll');
            localStorage.removeItem('priorityCatalog');
            localStorage.removeItem('infoTiposTicket');
            localStorage.removeItem('findInfoTicketTypes');
            localStorage.removeItem('tiposTicket');
            localStorage.removeItem('allProfiles');
            localStorage.removeItem('workShifts');
            localStorage.removeItem('usersBySupervisor');
            
            // localStorage.clear();
            this.router.navigate(['login']);
        }
    }

    isTokenValid(): boolean {
        return this._token !== null && this._token.expires_in > new Date().getTime();
    }

    get token(): TokenManager {
        return this._token;
    }

    loadToken(value: TokenManager): TokenManager {
        this._token = value;
        if (value === null) {
            localStorage.removeItem("auth_token");
            localStorage.removeItem("statusMenu");
            localStorage.removeItem("info_user_logged");
            localStorage.removeItem("cajero");
            localStorage.removeItem("cuadrillas_estados"); //conexiones de cuadrillas

            //Cokies
            localStorage.removeItem('userData');
            localStorage.removeItem('groupsAll');
            localStorage.removeItem('allTypesTicket');
            localStorage.removeItem('userGroupsAll');
            localStorage.removeItem('priorityCatalog');
            localStorage.removeItem('infoTiposTicket');
            localStorage.removeItem('findInfoTicketTypes');
            localStorage.removeItem('tiposTicket');
            localStorage.removeItem('allProfiles');
            localStorage.removeItem('workShifts');
            localStorage.removeItem('usersBySupervisor');
            
            // localStorage.clear();
        }
        else {
            this._token.expires_in = (new Date().getTime() + ((this._token.expires_in - 1) * 1000));
            console.debug(`Token expires in: ${new Date(this._token.expires_in)}`);
            localStorage.setItem("auth_token", JSON.stringify(this._token));
        }
        return this._token;
    }

    login(login: Login): Observable<TokenManager> {
        let body: URLSearchParams = new URLSearchParams();
        body.append("grant_type", "password");
        body.append("client_id", environment.client_id);
        body.append("client_secret", environment.client_secret);
        body.append("username", login.username);
        body.append("password", login.password);
        body.append('type_client', '1'); 
        body.append("dispositivo", login.dispositivo);
        body.append('type_client',  '1');
        body.append('codigo',  login.codigo);
        body.append('reCaptcha', login.reCaptcha);
        let options: RequestOptions = new RequestOptions();
        options.headers = new Headers();
        options.headers.append("Content-Type", "application/x-www-form-urlencoded");
        return this.http.post(environment.oauth_server, body, options).map(res => this.loadToken(res.json()));
    }

    refreshToken(): Observable<TokenManager> {
        if (!this._isTokenRefreshing) {
            this._isTokenRefreshing = true;
            let body: URLSearchParams = new URLSearchParams();
            body.append('grant_type', 'refresh_token');
            body.append('client_id', environment.client_id);
            body.append('client_secret', environment.client_secret);
            body.append('type_client', '1'); 
            body.append("refresh_token", this._token.refresh_token);
            body.append('type_client',  '1');
            let options: RequestOptions = new RequestOptions();
            options.headers = new Headers();
            options.headers.append("Content-Type", "application/x-www-form-urlencoded");
            return this.http.post(environment.oauth_server, body, options)
                .map(res => {
                    let token = this.loadToken(res.json());
                    this._isTokenRefreshing = false;
                    this._refreshing.next(token);
                    return token;
                }).catch(err => {
                    this._isTokenRefreshing = false;
                    this._refreshing.error(err);
                    this.loadToken(null);
                    return Observable.throw(err);
                });
        } else {
            return this._refreshing.asObservable();
        }
    }

    logout() {
        // Borramos datos del chat
        localStorage.removeItem('id_session');
        localStorage.removeItem('IAM');
        localStorage.removeItem('chat_history');
        localStorage.removeItem('cuadrillas_estados'); //estado de conexion de cuadrillas
        let options: RequestOptions = new RequestOptions();
        options.headers = new Headers();
        options.headers.append('Content-Type', this.LOG_OUT.contentType);
        options.headers.append('Authorization', this.token.token_type + " " + this.token.access_token);
        this.http.post(environment.api_url + this.LOG_OUT.uri, {}, options)
            .subscribe(next => {
                this.loadToken(null);
                this.router.navigate(['login']);
            }, () => {
                this.loadToken(null);
                this.router.navigate(['login']);
                location.reload();
            });
    }

    updatePassword(body: any): Observable<any> {
        if (body) {
            let url = environment.api_url + this.UPDATE_PASSWORD.uri;
          return  this.http.put(url,
            body
          ).pipe(
            map(() => {return true},
            catchError((error) => {
                try {
                    error = error.json();
                } catch (e) {}
                return throwError(error);
            })
        ));
      } else {
          return throwError({message: 'Sin información para crear venta'});
      }
    }


    getMsg401(error): ErrorMsg401 {
        const destinationMatch = error.message.match(/destination=([^,}]*)/);
        const destinationValue = destinationMatch ? destinationMatch[1] : null;
        const viaMatch = error.message.match(/Vía=([^}]*)/);
        const viaValue = viaMatch ? viaMatch[1] : null;

        let msg: ErrorMsg401 = {
            destination: destinationValue,
            via: viaValue
        }
        return msg;
    }
}

@Injectable()
export class Login {
    public username: string;
    public body: any;
    public token: any;
    public grant_type: string;
    public client_id: string;
    public client_secret: string;
    public password: string;
    public dispositivo: string;
    public roles: Array<string>;
    public type_client: number = 1;
    public codigo?: any;
    public reCaptcha: string;
}

@Injectable()
export class TokenManager {
    public access_token: string;
    public token_type: string;
    public refresh_token: string;
    public userId: number;
    public expires_in: number;
    public hier_token: string;
    public scope: string;
    public roles: Array<string>;
    public name: string;
    public username: string;
}

export class ErrorMsg401{
    destination: string;
    via: string;
}
